import RecordRTC from 'recordrtc';
import { resolutions } from '../RecorderConstants';
import { getDevices } from './getDevicesSelector';

// Flag to track whether devices are available
let isDevicesAvailable = false;

// Function to set up camera and audio streams for recording
export const setStream = async (selectedResolution, selectedCameraId, selectedAudioId, recorderParams, videoRef, canvas, setResolution, updateVideoStatus, setDevices, combinedStream, isBgEnabled, applyVirtualBackground) => {
    // Define media parameters for camera and audio capture
    const mediaParams = { audio: true };
    // Flag to check if the webm MIME type is supported
    let webmMimeType = true;
    // Adjust media parameters based on selected resolution and background mode
    if (selectedResolution) {
        if (isBgEnabled) {
            mediaParams.video = resolutions.find((resolution) => resolution.label === '480p').value;
        } else {
            mediaParams.video = selectedResolution;
        }
    }
    if (selectedCameraId) {
        mediaParams.video.deviceId = selectedCameraId;
    }
    if (selectedAudioId) {
        mediaParams.audio = { deviceId: selectedAudioId };
    }
    try {
        // Capture camera and microphone streams
        const stream = await navigator.mediaDevices.getUserMedia(mediaParams);
        if (!stream) return;
        // Set the camera stream as the source for the video element
        if (videoRef.current) {
            videoRef.current.srcObject = stream;
            videoRef.current.oncanplay = () => {
                videoRef.current.play();
            };
        }
        // Apply virtual background if enabled
        if (isBgEnabled) applyVirtualBackground();
        // Fetch available devices if not already available
        if (!isDevicesAvailable) {
            getDevices({ selectedCameraId, selectedAudioId })
                .then((result) => {
                    const { cameraDevices, audioDevices } = result;
                    isDevicesAvailable = cameraDevices.find((device) => device.deviceId).length > 0 && audioDevices.find((device) => device.deviceId).length > 0;
                    setDevices(cameraDevices, audioDevices);
                })
                .catch((error) => {
                    // Handle any errors if they occur
                    console.error('Error:', error);
                });
        }
        // Update video status to indicate beginning of recording
        updateVideoStatus('beginRecording');
        // Determine the MIME type for recording based on browser support
        if (typeof window.MediaRecorder.isTypeSupported === 'function') {
            if (window.MediaRecorder.isTypeSupported('video/webm;codecs=vp9')) {
                recorderParams.mimeType = 'video/webm;codecs=vp9';
            } else if (window.MediaRecorder.isTypeSupported('video/webm;codecs=h264')) {
                recorderParams.mimeType = 'video/webm;codecs=h264';
            } else if (window.MediaRecorder.isTypeSupported('video/webm')) {
                recorderParams.mimeType = 'video/webm';
            } else if (window.MediaRecorder.isTypeSupported('video/mp4')) {
                recorderParams.mimeType = 'video/mp4';
                webmMimeType = false;
            }
        } else {
            // Test for webm support
            var testVideo = document.createElement('video');
            if (testVideo.canPlayType && testVideo.canPlayType('video/webm; codecs="vp8, vorbis"') !== '') {
                recorderParams.mimeType = 'video/webm';
                webmMimeType = true;
            } else {
                recorderParams.mimeType = 'video/mp4';
                webmMimeType = false;
            }
        }
        // Set up combined stream for virtual background recording if enabled
        if (isBgEnabled) {
            const videoTrack = canvas.captureStream().getVideoTracks()[0];
            const audioTrack = stream.getAudioTracks()[0];
            combinedStream = new MediaStream();
            combinedStream.addTrack(videoTrack);
            combinedStream.addTrack(audioTrack);
        }
        // Prepare the result object with necessary details
        const result = {
            cameraStream: stream,
            combinedStream: combinedStream,
            cameraRecorder: new RecordRTC(isBgEnabled ? combinedStream : stream, { type: recorderParams }),
            recorderParam: recorderParams,
            webmMimeType,
        };
        return result;
    } catch (err) {
        // Handle different types of errors and update video status accordingly
        if (err.name === 'AbortError') {
            // some problem occurred which prevented the device from being used.
        } else if (err.name === 'NotAllowedError') {
            // permission denied in browser
        } else if (err.name === 'NotFoundError') {
            // no camera or microphone found
        } else if (err.name === 'NotReadableError') {
            // a hardware error occurred at the operating system, or browser
            // which prevented access to the device.
        } else if (err.name === 'OverconstrainedError') {
            // constraints can not be satisfied by the devices
            // if the current resolution isn't supported, let's try the next option
            let lowerResOption;
            resolutions.map((resolution, i) => {
                console.log(resolution, selectedResolution);
                if (resolution.value === selectedResolution && resolutions[i + 1]) {
                    resolution.supported = false;
                    lowerResOption = resolutions[i + 1];
                }
            });
            console.log(resolutions);
            if (lowerResOption) {
                setResolution(lowerResOption);
                return;
            }
        } else if (err.name === 'SecurityError') {
            // User media support is disabled on the document
        } else if (err.name === 'TypeError') {
            // the list of constraints specified is empty, or has all constraints set to false
        } else {
            // other unknown error
        }
        console.log('device error', err);
        // for all errors, let's currently show that the state
        // where the camera is denied
        updateVideoStatus('cameraDenied');
    }
};
